import Vue from 'vue';

const USER_INFO = (state, user) => {
	user.expired_time = moment(user.expired_time).format('DD/MM/Y');
	if(user.clone_id != 0){
		let c = user.code.split("sub")[0];
		user.code = c == "administrator" ? "" : c;
	}
    state.user = user;
    Vue.set(state, 'user', user);
}

export default {
    USER_INFO,
};